import React, { useState, useRef } from 'react';
import ApiCheckout from '../../adapters/apiCheckout';
import OPTLayout from '../../components/terminal/layouts/OPTLayout';
import OPTHomeScreen from '../../components/terminal/opt/OPTHomeScreen';
import OPTSelectFuel from '../../components/terminal/opt/OPTSelectFuel';
import OPTInsertTapCard from '../../components/terminal/opt/OPTInsertTapCard';
import OPTEnterPin from '../../components/terminal/opt/OPTEnterPin';
import OPTVerifying from '../../components/terminal/opt/OPTVerifying';
import OPTApproved from '../../components/terminal/opt/OPTApproved';
import OPTReceipt from '../../components/terminal/opt/OPTReceipt';
import OPTThankYou from '../../components/terminal/opt/OPTThankYou';

export default function OPT() {
    const [currentScreen, setCurrentScreen] = useState('home');
    const [transactionResponse, setTransactionResponse] = useState(null);
    const [amountValueCaptured, setAmount] = useState(null);
    const apiCheckout = useRef(new ApiCheckout());

    const handleEnterAmount = () => setCurrentScreen('select-fuel');
    const handleCancel = () => setCurrentScreen('home');

    const handleFuelSelected = (amount) => {
        setAmount(amount);
        setCurrentScreen('insert-tap-card');
    };

    const handleCardDetected = () => {
        setCurrentScreen('enter-pin');
    };

    const handlePinCancel = () => setCurrentScreen('home');

    const handlePinSubmit = async (pin) => {
        setCurrentScreen('verifying');
        
        try {
            const response = await apiCheckout.current.createTerminalSale(amountValueCaptured);
            console.log('Terminal sale response:', response);
            handleVerificationComplete({ successful: true, ...response });
        } catch (error) {
            console.error('Terminal sale error:', error);
            const errorObj = typeof error === 'object' && error !== null ? error : {};
            handleVerificationComplete({ successful: false, ...errorObj });
        }
    };

    const handleVerificationComplete = (response) => {
        setTransactionResponse(response);
        setCurrentScreen('approved');
    };

    const handleApprovedContinue = () => setCurrentScreen('receipt');
    const handleApprovedCancel = () => setCurrentScreen('home');
    const handleYesClick = () => setCurrentScreen('thank-you');
    const handleNoClick = () => setCurrentScreen('thank-you');
    const handleEmail = () => setCurrentScreen('thank-you');
    const handleSms = () => setCurrentScreen('thank-you');

    const handleNewTransaction = () => {
        setCurrentScreen('home');
        setTransactionResponse(null);
        setAmount(null);
    };

    const renderCurrentScreen = () => {
        switch (currentScreen) {
            case 'home':
                return <OPTHomeScreen onEnterAmount={handleEnterAmount} />;
            case 'select-fuel':
                return <OPTSelectFuel onSelectAmount={handleFuelSelected} onCancel={handleCancel} />;
            case 'insert-tap-card':
                return <OPTInsertTapCard amount={amountValueCaptured} onCardDetected={handleCardDetected} />;
            case 'enter-pin':
                return <OPTEnterPin onCancel={handlePinCancel} onSubmit={handlePinSubmit} amount={amountValueCaptured} />;
            case 'verifying':
                return <OPTVerifying />;
            case 'approved':
                return <OPTApproved onCancel={handleApprovedCancel} onTimeout={handleApprovedContinue} amount={amountValueCaptured} />;
            case 'receipt':
                return <OPTReceipt onYes={handleYesClick} onNo={handleNoClick} onEmail={handleEmail} onSms={handleSms} amount={amountValueCaptured} />;
            case 'thank-you':
                return <OPTThankYou onNewTransaction={handleNewTransaction} />;
            default:
                return <OPTHomeScreen onEnterAmount={handleEnterAmount} />;
        }
    };

    return (
        <div className="min-h-screen bg-gray-800">
            <OPTLayout>
                {renderCurrentScreen()}
            </OPTLayout>
            
            <div className="bg-gray-800 p-2 rounded-b mt-2 max-w-5xl mx-auto">
                <div className="text-center text-green-400 font-mono text-xs">
                    OPT STATUS: READY | FUEL PUMP: CONNECTED | TIME: {new Date().toLocaleTimeString()}
                </div>
            </div>
        </div>
    );
}
